import { render, staticRenderFns } from "./vRenMasiva.vue?vue&type=template&id=65581d9c&scoped=true&"
import script from "./vRenMasiva.vue?vue&type=script&lang=js&"
export * from "./vRenMasiva.vue?vue&type=script&lang=js&"
import style0 from "./vRenMasiva.vue?vue&type=style&index=0&id=65581d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65581d9c",
  null
  
)

export default component.exports